/**
 * Popup, signup, and age-gate. Loaded from sections/popup.liquid as type="module".
 */

const SELECTOR = '[data-section-type="popup"]'
const STORAGE_PREFIX = 'fluco_'

function initCountdown(container) {
  const settingsEl = container.querySelector('[data-timer-settings]')
  if (!settingsEl) return () => {}
  let settings
  try {
    settings = JSON.parse(settingsEl.innerHTML)
  } catch (error) {
    return () => {}
  }
  const timezone = settings.timeZoneSelection === 'shop' ? ` GMT${settings.shopTimezone}` : ''
  const end = Date.parse(`${settings.month} ${settings.day}, ${settings.year} ${settings.hour}:${settings.minute}${timezone}`)
  const daysEl = container.querySelector('[data-days]')
  const hoursEl = container.querySelector('[data-hours]')
  const minutesEl = container.querySelector('[data-minutes]')
  const secondsEl = container.querySelector('[data-seconds]')
  container.classList.add('active')

  const tick = () => {
    const distance = end - Date.now()
    if (distance < 0) {
      window.clearInterval(timer)
      ;[daysEl, hoursEl, minutesEl, secondsEl].forEach((el) => {
        if (el) el.innerHTML = '0'
      })
      container.classList.add('complete')
      if (settings.hideTimerOnComplete) container.classList.add('hide')
      return
    }
    if (daysEl) daysEl.innerHTML = String(Math.floor(distance / 86400000))
    if (hoursEl) hoursEl.innerHTML = String(Math.floor((distance % 86400000) / 3600000))
    if (minutesEl) minutesEl.innerHTML = String(Math.floor((distance % 3600000) / 60000))
    if (secondsEl) secondsEl.innerHTML = String(Math.floor((distance % 60000) / 1000))
  }
  const timer = window.setInterval(tick, 1000)
  tick()
  return () => window.clearInterval(timer)
}

function readFlag(key) {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_PREFIX + key))
  } catch (error) {
    return null
  }
}

function writeFlag(key) {
  try {
    localStorage.setItem(STORAGE_PREFIX + key, JSON.stringify(new Date()))
  } catch (error) {}
}

function initPopupInstance(container) {
  const wash = container.querySelector('.popup__wash')
  const dismissButtons = container.querySelectorAll('[data-dismiss-popup]')
  const formSuccessMessage = container.querySelector('.form-status__message--success')
  const timerEl = container.querySelector('[data-countdown-timer]')
  const { delayType, showOnExitIntent, id, isSignup, popupType } = container.dataset
  const tab = document.querySelector(`.popup__tab[data-id="${id}"]`)
  const delayValue = parseInt(container.dataset.delayValue, 10)
  const hourFrequency = parseInt(container.dataset.hourFrequency, 10)
  const storageKey = `popup-${id}`
  const signupSubmittedKey = `signup-submitted-${id}`
  const formSuccessKey = `form-success-${id}`
  const signupDismissedKey = `signup-dismissed-${id}`
  const ageVerifiedKey = `age-verified-${id}`
  const isSignupPopup = isSignup === 'true'
  const isAgeVerification = popupType === 'age'
  let hasPoppedUp = false
  let canPopUp = true
  const destroyTimer = timerEl ? initCountdown(timerEl) : () => {}

  const lockScroll = (lock) => {
    document.body.style.overflow = lock ? 'hidden' : ''
    document.body.setAttribute('data-fluorescent-overlay-open', lock ? 'true' : 'false')
  }

  const showPopup = () => {
    container.classList.add('visible')
    if (popupType === 'popup' || popupType === 'age') lockScroll(true)
    hasPoppedUp = true
    if (tab && !window.Shopify?.designMode) tab.classList.remove('visible')
    if (window.Shopify?.designMode && tab) tab.classList.add('visible')
  }

  const hidePopup = () => {
    container.classList.remove('visible')
    if (isSignupPopup) {
      writeFlag(signupDismissedKey)
      if (tab) tab.classList.add('visible')
    }
    if (isAgeVerification) writeFlag(ageVerifiedKey)
    window.setTimeout(() => {
      if (popupType === 'popup' || popupType === 'age') lockScroll(false)
    }, 500)
  }

  if (window.Shopify?.designMode) {
    canPopUp = false
  } else if ((isAgeVerification && readFlag(ageVerifiedKey)) || (isSignupPopup && readFlag(signupSubmittedKey))) {
    canPopUp = false
  } else if (isSignupPopup && readFlag(signupDismissedKey)) {
    canPopUp = false
    if (tab) tab.classList.add('visible')
  } else if (!isSignupPopup && !isAgeVerification && readFlag(storageKey)) {
    canPopUp = (Date.now() - new Date(readFlag(storageKey))) / 3600000 > hourFrequency
  }

  if (!window.Shopify?.designMode) {
    dismissButtons.forEach((button) => button.addEventListener('click', hidePopup))
    if (!isAgeVerification && wash) {
      wash.addEventListener('click', hidePopup)
      container.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') hidePopup()
      })
    }
  }

  if (isSignupPopup) {
    const form = container.querySelector('.newsletter-form')
    if (form) form.addEventListener('submit', () => writeFlag(signupSubmittedKey))
  }

  if (tab) {
    tab.querySelector('.popup__tab-button')?.addEventListener('click', showPopup)
    tab.querySelector('.popup__tab-dismiss')?.addEventListener('click', () => {
      tab.classList.remove('visible')
      try {
        localStorage.removeItem(STORAGE_PREFIX + signupDismissedKey)
      } catch (error) {}
    })
  }

  if (isSignupPopup && formSuccessMessage && !readFlag(formSuccessKey)) {
    writeFlag(formSuccessKey)
    showPopup()
  } else if (canPopUp) {
    if (delayType === 'timer') {
      window.setTimeout(() => {
        if (!hasPoppedUp) {
          showPopup()
          writeFlag(storageKey)
        }
      }, delayValue)
    } else if (delayType === 'scroll') {
      window.addEventListener(
        'load',
        () => {
          const target = (document.body.scrollHeight - window.innerHeight) * (delayValue / 100)
          const onScroll = () => {
            if (window.scrollY >= target && !hasPoppedUp) {
              showPopup()
              writeFlag(storageKey)
              window.removeEventListener('scroll', onScroll)
            }
          }
          window.addEventListener('scroll', onScroll, { passive: true })
        },
        { once: true }
      )
    }
    if (showOnExitIntent === 'true' && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      const onLeave = (e) => {
        if (!e.relatedTarget && !hasPoppedUp) {
          showPopup()
          writeFlag(storageKey)
          document.body.removeEventListener('mouseout', onLeave)
        }
      }
      document.body.addEventListener('mouseout', onLeave)
    }
  }

  return {
    showPopup,
    unload() {
      hidePopup()
      destroyTimer()
    },
  }
}

function init(root) {
  if (root.dataset.popupInit) return
  root.dataset.popupInit = 'true'

  const instances = [...root.querySelectorAll('[data-popup]')].map((el) => initPopupInstance(el))
  document.addEventListener('shopify:block:select', (event) => {
    if (event.detail?.sectionId !== root.dataset.sectionId) return
    instances.find((item) => item && [...root.querySelectorAll('[data-popup]')].includes(event.target))?.showPopup()
  })
}

function initAll(scope = document) {
  if (scope.matches?.(SELECTOR)) init(scope)
  scope.querySelectorAll(SELECTOR).forEach(init)
}

initAll()
document.addEventListener('shopify:section:load', (event) => initAll(event.target))
